import { call, put, type CallEffect, type PutEffect } from 'redux-saga/effects';

type LedgerRequestPayload = {
    projectID?: string | number;
    projectId?: string | number;
    errorCB?: (message: string) => void;
};

/** Both legacy project stores share action names, but callers use two ID spellings. */
export function* requestProjectLedger(
    payload: LedgerRequestPayload,
    getLedgerData: (id: string) => unknown,
    actions: { store: string; error: string }
): Generator<CallEffect | PutEffect, void, any> {
    const rawId = payload.projectID ?? payload.projectId;
    const id = String(rawId ?? '').trim();
    if (!/^\d+$/.test(id) || Number(id) <= 0) {
        const message = 'A project ID is required to fetch the ledger';
        yield put({ type: actions.error, payload: { error: { message } } });
        payload.errorCB?.(message);
        return;
    }
    try {
        const { data } = yield call(getLedgerData, id);
        yield put({ type: actions.store, payload: data });
    } catch (error: unknown) {
        yield put({ type: actions.error, payload: { error } });
        const message = error && typeof error === 'object' && 'message' in error
            ? String(error.message) : 'Unable to fetch the ledger';
        payload.errorCB?.(message);
    }
}
